export default "__VITE_ASSET__5I$vqzxf__"